module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAMAAADypuvZAAAAWlBMVEUAAAD/VVX/bUn/YFD/aVr/a1H/ZlL/aFX/ZFL/ZlP/ZFf/Z1X/ZVP/ZVT/ZlP/ZVT/ZFT/ZVT/ZlP/ZVT/ZVX/ZVT/ZVT/ZVT/ZlT/ZVT/ZVT/ZVT/ZVT/ZVRXBRwRAAAAHXRSTlMAAwcQERMZGxwoKSpHfJmam6eoqsTR1dfY7u/5/H0TJbQAAACrSURBVEjH7ZbJEoIwEAVbdjGIbCLg+//f9OB2sSSJS5UWfe8cpqYyDYAp+0mzTH1puBLVsqaOzk7YaizygFmCvBjVhgBU6lIsSTtVAEZDhjXZIAOUKnCg0BbolbtIG+2Bo1YuUqAJkHBC+k3p0QJ9RvrH6S2Sj/Ts83qvtIx8kZbde03yOp9eh9orCbzig0pdYuskl8xxCKr1PaiIG/t0a+LbG5aReNgZvswJTv46FkBEmskAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/course/chengji@2x.png
// module id = APEA
// module chunks = 0